import { Component, computed, ViewChild, ElementRef, Output, EventEmitter, NgZone, effect, Input, signal, ChangeDetectionStrategy } from '@angular/core';

import { FormsModule } from '@angular/forms';
import { GenetricDetailComponent } from '@app/common-codes/components/edit-components/generic-detail.component';
import { Register } from '@app/common-codes/decorators/DependencyInjectionRegistreyDecorators';
import { MatwinsSkins } from '@app/common-codes/skins/global.skin';
import { IStaticStylesConfig } from '@app/common-codes/skins/_primitives/IStaticStylesConfig';
import { TranslatePipe } from '@app/common-codes/components/directives/TranslatePipe';
import { GenericValidationService } from '@app/common-codes/services/GenericValidationService';
import { TranslationService } from '@app/common-codes/services/TranslationService';
import { ActivatedRoute, Router } from '@angular/router';
import { OnReadyDirective } from '@app/common-codes/components/directives/OnReadyDirective';
import { AlertModalService } from '@app/common-codes/services/AlertModalService';
import { Role } from '@app/common-codes/models/matwins-tenant/Role.model';
import { LookupItem, LookupService } from '@app/common-codes/services/LookupService';
import { ReactiveBadgeComponent } from '@app/common-codes/components/nested-components/reactive-badge/reactive-badge.component';
import { MultiSelectComponent } from '@app/common-codes/components/nested-components/multi-select/multi-select.component';
import { TreeNode } from '@app/common-codes/components/nested-components/tree-node/tree-node.component';
import { TreeViewComponent } from '@app/common-codes/components/nested-components/tree-view/tree-view.component';
import { PermissionsService } from '@app/common-codes/services/Permissions.service';
import { GenericEntityBase } from '@app/common-codes/_models/GenericEntityBase';
import { All_ExclusiveFeature_Keys } from '@app/common-codes/models/permissions/common-files/extracted-features';


@Register(Role)
@Component({
  selector: 'app-role-detail',
  templateUrl: './role-detail.component.html',
  standalone: true,
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [FormsModule, TranslatePipe, OnReadyDirective, TreeViewComponent]
})
export class RoleDetailComponent extends GenetricDetailComponent<Role> {

  override ComponentEntityClass = Role;
  @Input() fkPointOfServiceId: number | null = null;
  Skin = MatwinsSkins.V1 as IStaticStylesConfig;
  @Output() itemSaved = new EventEmitter<Role>();

  permissionsData!: TreeNode;

  entityNames: string[] = GenericEntityBase.EntityFullNames; //['Client', 'PointOfService', 'Dock', 'Trucker', 'TruckerActivity']; //GenericEntityBase.EntityFullNames; 
  featureNames: string[] = All_ExclusiveFeature_Keys; // ['EmployeeList.ExportPDF_Button', 'AccountDetail.ShowPermissions_Button', 'TruckerActivity.ImageContainer_Component'];
  

  constructor(
    route: ActivatedRoute,
    router: Router,
    translationService: TranslationService,
    validationService: GenericValidationService,
    alertModalService: AlertModalService,
    ngZone: NgZone
  ) {
    super(route, router, translationService, validationService, ngZone);
    this.alertModalService = alertModalService;

    effect(() => {
      const entity = this.editingEntity();
      if (entity) {
        if (entity.defaultPermissions === '{}')
          entity.defaultPermissions = JSON.stringify(this.permissionsService.GenerateDefaultPermissionsForRole(this.entityNames, this.featureNames)); // JSON.stringify(permissionsData);

        this.permissionsData = JSON.parse(entity.defaultPermissions);

      }
    });
  }

  override getEmptyEntity(): Role {
    const role = new Role();
    role.defaultPermissions = JSON.stringify(this.permissionsService?.GenerateDefaultPermissionsForRole(this.entityNames, this.featureNames)); // JSON.stringify(permissionsData);

    return role;
  }

  override parseToEntityInstance(): void {
    if (this.EntityInstance && this.editingEntity()) {
      Object.assign(this.EntityInstance, this.editingEntity());
    }
  }

  onChange(data: TreeNode) {
    this.editingEntity()!.defaultPermissions = JSON.stringify(data);
  }

  async saveItem(): Promise<void> {
    const savedItem = await this.save();
    if (savedItem) {
      this.itemSaved.emit(savedItem);
    }
  }

  async saveAndCloseItem(): Promise<void> {
    const savedItem = await this.save();
    if (savedItem) {
      this.itemSaved.emit(savedItem);
      this.closeModal.emit();
    }
  }

}
